import React from 'react';
import { ArrowUpRightIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { NewTabHint } from '../ui/NewTabHint';
import type { BcmEvent } from '../../data/events';
const dotStyles: Record<BcmEvent['category'], string> = {
  'Fall 2026': 'bg-brand-yellow',
  Weekly: 'bg-brand-blue',
  'Coming Soon': 'bg-brand-pink'
};

/**
 * Compact calendar-style list view. Reads the same event data as the card view.
 */
export function EventList({
  events
}: {
  events: BcmEvent[];
}) {
  return <ul className="overflow-hidden rounded-[24px] border-2 border-brand-navy bg-white" data-id="element-107" data-mp="dy0eabkkt8dp">
      {events.map((event, index) => <li key={event.id} className={`flex flex-col gap-3 p-5 sm:flex-row sm:items-start sm:gap-6 sm:p-6 ${index > 0 ? 'border-t-2 border-brand-navy/15' : ''}`} data-id="element-108" data-mp="ro3uaksv45up" data-mpi={index}>
          <div className="sm:w-56 sm:shrink-0" data-id="element-109" data-mp="11nukiaae3yoz">
            <p className="flex items-center gap-2 font-meta text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy" data-id="element-110" data-mp="woi1y1qjxds7">
              <span aria-hidden="true" className={`h-2.5 w-2.5 rounded-full ${dotStyles[event.category]}`} data-id="element-111" data-mp="2v538ovh6vu8t" />
              {event.category}
            </p>
            <p className="mt-1.5 font-display text-base font-bold leading-snug text-brand-navy" data-id="element-112" data-mp="344g8ewfih4gc">
              {event.date}
            </p>
            {event.time ? <p className="mt-1 flex items-center gap-1.5 font-meta text-[13px] text-ink" data-id="element-113" data-mp="394uisl4l4qhj">
                <ClockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-114" data-mp="3e2dubd9wep5s" />
                {event.time}
              </p> : null}
          </div>

          <div className="min-w-0" data-id="element-115" data-mp="3nrxgoswtl15e">
            <h3 className="font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-116" data-mp="3nsz13nzq6zzs">
              {event.title}
            </h3>
            <p className="mt-1.5 font-sans text-[15px] leading-relaxed text-ink" data-id="element-117" data-mp="3rvvhr95pgm13">
              {event.description}
            </p>
            {event.locationDetail || event.location || event.locationNote ? <p className="mt-2 flex items-start gap-1.5 font-meta text-[13px] text-ink" data-id="element-118" data-mp="21ppfr80azcd0">
                <MapPinIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-navy" data-id="element-119" data-mp="1wqw3fiwr5ref" />
                {event.locationDetail ?? event.location ?? event.locationNote}
              </p> : null}
            {event.clarification ? <p className="mt-1.5 font-meta text-[12.5px] text-ink" data-id="element-120" data-mp="26nh9m7kid8ju">{event.clarification}</p> : null}
            <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2" data-id="element-121" data-mp="2kijldbc1ds4k">
              {event.cta ? <a href={event.cta.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 hover:no-underline" data-id="element-122" data-mp="2ggy134x6abkc">
                  {event.cta.label}
                  <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-123" data-mp="v2bu9nxfu76v" />
                  <NewTabHint data-id="element-124" data-mp="36p5m59x16qrx" />
                </a> : null}
              {event.reference ? <a href={event.reference.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 hover:no-underline" data-id="element-125" data-mp="3boi4bhcyj9o6">
                  {event.reference.label}
                  <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-126" data-mp="2o0quckew38q2" />
                  <NewTabHint data-id="element-127" data-mp="2syse77k53c2l" />
                </a> : null}
            </div>
          </div>
        </li>)}
    </ul>;
}